var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.item.absent)?_c('AdButton',{attrs:{"icon":_vm.item.type === 'group' ? 'mdi-checkbox-multiple-marked' : 'mdi-checkbox-marked',"text":"-","disabled":!_vm.editMode},on:{"click":function($event){return _vm.unselectItem()}}}):_c('AdSpeedDial',{attrs:{"disabled":!_vm.editMode,"open-on-hover":false,"dropdown":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('AdButton',_vm._g(_vm._b({attrs:{"icon":_vm.item.type === 'group' ? 'mdi-checkbox-multiple-blank-outline' : 'mdi-checkbox-blank-outline',"disabled":!_vm.editMode,"text":"+","no-margin-right":""}},'AdButton',attrs,false),on))]}}])},[(_vm.item.absent && _vm.item.type === 'item')?[_c('AdSpeedOption',{attrs:{"text":"0..1 R","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '0',
            itemMax: '1',
            itemConf: 'R',
          })}}}),_c('AdSpeedOption',{attrs:{"text":"0..1 C","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '0',
            itemMax: '1',
            itemConf: 'C',
          })}}}),_c('AdSpeedOption',{attrs:{"text":"0..1 O","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '0',
            itemMax: '1',
            itemConf: 'O',
          })}}}),_c('AdSpeedOption',{attrs:{"text":"1..1 R","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '1',
            itemMax: '1',
            itemConf: 'R',
          })}}}),_c('AdSpeedOption',{attrs:{"text":"1..1 M","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '1',
            itemMax: '1',
            itemConf: 'M',
          })}}}),_c('AdSpeedOption',{attrs:{"text":"1..1 C","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '1',
            itemMax: '1',
            itemConf: 'C',
          })}}}),_c('AdSpeedOption',{attrs:{"text":"0..* R","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '0',
            itemMax: '*',
            itemConf: 'R',
          })}}}),_c('AdSpeedOption',{attrs:{"text":"1..* R","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '1',
            itemMax: '*',
            itemConf: 'R',
          })}}}),_c('AdSpeedOption',{attrs:{"text":"1..* M","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '1',
            itemMax: '*',
            itemConf: 'M',
          })}}}),_c('AdSpeedOption',{attrs:{"text":"1..* C","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '1',
            itemMax: '*',
            itemConf: 'C',
          })}}}),_c('AdSpeedOption',{attrs:{"text":"NP","list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '0',
            itemMax: '0',
            itemConf: 'NP',
          })}}})]:_vm._e(),(_vm.item.absent && _vm.item.type === 'group')?[_c('AdSpeedOption',{attrs:{"text":`${_vm.$t('all')} 0`,"list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'group',
            itemMin: '0',
            itemMax: '1',
            itemConf: 'O',
          })}}}),_c('AdSpeedOption',{attrs:{"text":_vm.$t('all-zero-one'),"list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'group',
            itemMin: '0',
            itemMax: '1',
            itemConf: 'R',
          })}}}),_c('AdSpeedOption',{attrs:{"text":_vm.$t('all-one-one'),"list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'group',
            itemMin: '1',
            itemMax: '1',
            itemConf: 'R',
          })}}}),_c('AdSpeedOption',{attrs:{"text":_vm.$t('groups-one-one-items-zero-one'),"list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'group',
            itemMin: '1',
            itemMax: '1',
            itemConf: 'R',
            childMin: '0',
            childMax: '1',
            childConf: 'R',
          })}}}),_c('AdSpeedOption',{attrs:{"text":_vm.$t('groups-zero-one-items-one-one'),"list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'group',
            itemMin: '0',
            itemMax: '1',
            itemConf: 'R',
            childMin: '1',
            childMax: '1',
            childConf: 'R',
          })}}}),_c('AdSpeedOption',{attrs:{"text":_vm.$t('group-only-one-one'),"list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '1',
            itemMax: '1',
            itemConf: 'R',
          })}}}),_c('AdSpeedOption',{attrs:{"text":_vm.$t('group-only-zero-one'),"list":false,"list-item":""},on:{"click":function($event){return _vm.setCardConf({
            type: 'item',
            itemMin: '0',
            itemMax: '1',
            itemConf: 'R',
          })}}})]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }